

<div class="col-md-12 mb-30" style="margin-top: 20px;">
  <div class="card card-statistics h-100" [hidden]="DataList_Kartable_Selected_DeviceBehfa.id>0" >
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Issued Certificate Archive</h5>

      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Time Range</label>
          <select class="custom-select" [(ngModel)]="SubmitPeriodDate" name="SubmitPeriodDate">
            <option value="1">Apply</option>
            <option value="0">Do Not Apply</option>
          </select>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Start Date</label>
          <input type="text" #datepickerInputStart placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">End Date</label>
          <input type="text" #datepickerInputEnd placeholder="Type here..." class="form-control" />
          <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false"
            [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Certificate Number</label>
          <input [(ngModel)]="Filter_Certificate_User" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Certificate_User" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Customer Name</label>
          <input [(ngModel)]="Filter_Customer_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Customer_Order" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
         <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Calibration Technician Name</label>
          <input [(ngModel)]="Filter_Expert_Name_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Expert_Name_Order" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Instrument Code</label>
          <input [(ngModel)]="Filter_Device_Code" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Device_Code" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Instrument Serial Number</label>
          <input [(ngModel)]="Filter_Device_Serial" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Device_Serial" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>

      </div>

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Receipt Number</label>
          <input [(ngModel)]="Filter_RecieveCode_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_RecieveCode_Order" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Letter Number</label>
          <input [(ngModel)]="Filter_Code2_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Code2_Order" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">Instrument English Name</label>
          <input [(ngModel)]="Filter_Devicename_Order" (keyup.enter)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)" (keyup)="Change_Filter_Order()"
            name="Filter_Devicename_Order" type="text" class="form-control"
            placeholder="Type here to search...">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing_Kartable" type="button"
            (click)="ReadData_Kartable(datepickerInputStart.value,datepickerInputEnd.value)"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search
          </button>
          <img *ngIf="Procssing_Kartable" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-30" *ngFor="let item of DataList_Kartable
        |filter:Filter_Customer_Order:'customer'
        |filter:Filter_RecieveCode_Order:'recieveCode'
        |filter:Filter_Code2_Order:'code2'
        |filter:Filter_Devicename_Order:'devicename'
        |filter:Filter_Expert_Name_Order:'expert_name'
        |filter:Filter_Certificate_User:'certificate_user_code'
        |filter:Filter_Device_Code:'code'
        |filter:Filter_Device_Serial:'serial'
        | paginate
                : {
                    id: 'DataList_Kartable',
                    itemsPerPage: 20,
                    currentPage: page_Kartable,
                    totalItems: (DataList_Kartable
                    |filter:Filter_Customer_Order:'customer'
                    |filter:Filter_RecieveCode_Order:'recieveCode'
                    |filter:Filter_Code2_Order:'code2'
                    |filter:Filter_Devicename_Order:'devicename'
                    |filter:Filter_Expert_Name_Order:'expert_name'
                    |filter:Filter_Certificate_User:'certificate_user_code'
                    |filter:Filter_Device_Code:'code'
                    |filter:Filter_Device_Serial:'serial'
                    ).length
                  }
        ">

          <div class="card h-100">
            <div class="card-body">
              <div style="float: left;">
                <p><span  style="font-weight: 600;">Instrument</span>  '{{item.devicename}}' </p>
              </div>
              <div style="float: right;">
                <p>
                  <span  style="font-weight: 600;">Letter Number	</span> '{{item.code2}}'

                </p>
              </div>
              <div style="clear: both;"></div>
              <p>
                <span  style="font-weight: 600;">Customer Name	</span>
                 '{{item.customer}} ({{item.customer_code}})'
                 <span *ngIf="!item.expert_submit_date_visible" style="font-weight: 600;color: #031dd5;"> (New) </span>
              </p>
              <p>
                <span  style="font-weight: 600;"> Certificate Number </span>
                 '{{item.certificate_user_code}}'

              </p>

              <hr/>
              <div style="float: left;">
                <p><span  style="font-weight: 600;">Instrument Code </span> '{{item.code}}' </p>
                <p><span  style="font-weight: 600;">Instrument Serial Number</span> '{{item.serial}}' </p>
                <p><span  style="font-weight: 600;">Receipt Number</span> '{{item.recieveCode}}' </p>
                <p>
                  <span  style="font-weight: 600;">Location </span>
                  <span *ngIf="item.inlocation">At the Customer Site</span>
                  <span *ngIf="!item.inlocation">At the Laboratory</span>
                </p>
              </div>
              <div style="float: right;">
                <p><span  style="font-weight: 600;">Calibration Technician</span> '{{item.expert_name}}' </p>
                <p><span  style="font-weight: 600;">Status</span>  '{{item.status}}' </p>
                <p><span  style="font-weight: 600;">Delivery Date	</span>  '{{item.tarikhTahvi}}' </p>
                <p><span  style="font-weight: 600;">Date Approve	</span>  '{{item.expertSubmitDate}}' </p>
              </div>
              <div style="clear: both;"></div>

              <hr/>
              
              <span  *ngIf="item.flowchartRequestDsc">
                <hr/>
                <p><span  style="font-weight: 600;">Restore Certificate</span>  '{{item.flowchartRequestDsc}}' </p>
              </span>

              
              <p><span  style="font-weight: 600;">Tariff Description</span>  '{{item.tariff_dsc}}' </p>

              <hr/>


              <img *ngIf="item.Processing" src="assets/Loading.gif" style="width: 25px;" />



              <div *ngIf="!item.Processing">


                <div class="row">
                  <a *ngIf="item.filename" target="_blank" href="{{BaseUrl}}File/Calibration/{{item.filename}}" class="btn btn-info"><i class="fa fa-eye"></i> Calibration Certificate File </a>
                  <a  *ngIf="item.certificate && !item.filename" target="_blank" href="{{BaseUrl}}{{item.certificate}}" class="btn btn-info"><i class="fa fa-eye"></i> Calibration Certificate File </a>

                  <button type="button" style="margin-left: 10px;" (click)="OnSet_Calibration_DeviceBehfa(item)"  class="btn btn-warning"> <i class="fa fa-building"></i> Behfa Equipment
                  </button>

                  <button type="button" style="margin-left: 10px;" (click)="openModal_Certificate(templateCertificate,item)" class="btn btn-success"> <i class="fa fa-retweet"></i> Restore Certificate
                  </button>

                  <button type="button" *ngIf="item.controller.length>0" (click)="openModal_Controller(templateController,item)" style="margin-left: 10px;" class="btn btn-danger"><i
                      class="fa fa-file"></i> Reviewer Messages </button>

                </div>
              </div>



            </div>
          </div>
        </div>

      </div>

      <pagination-controls id="DataList_Kartable" nextLabel="Next" previousLabel="Previous"
        (pageChange)="page_Kartable = $event"></pagination-controls>


    </div>
  </div>

  <app-CalibrationDeviceBehfa *ngIf="DataList_Kartable_Selected_DeviceBehfa.id>0"
    (OnBack_CalibrationDeviceBehfa_Action)="OnSet_Back_Calibration_DeviceBehfa($event)"
    [inner_Kartable_Order_Interface]="DataList_Kartable_Selected_DeviceBehfa"
    [inner_Can_Add_Edit]="false"
    [inner_Persian_Date]="PersianToDayDate">

  </app-CalibrationDeviceBehfa>

</div>

<ng-template #templateCertificate>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Restore Certificate </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Certificate.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1"> Request Description </label>
        <input [(ngModel)]="Certificate_Dsc" name="Certificate_Dsc" type="text" class="form-control"
          placeholder="Type here...">
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button (click)="SubmitCertificate()" type="button" [disabled]="!Certificate_Dsc"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Certificate.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateController>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> Reviewer Messages '{{Selected_DataList_Calibration.devicename}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Controller.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th>User</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Controller_Data_List">
              <td>{{Controller_Data_List.indexOf(item)+1}}</td>
              <td>{{item.dsc}}</td>
              <td>{{item.title}}</td>
              <td>{{item.code}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_Controller.hide()">Close</button>
  </div>
</ng-template>
